import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { AnimatedCollapse } from 'client/site-modules/shared/utils/collapse-utils';
import classNames from 'classnames';
import { combineFacetValues } from 'site-modules/shared/utils/inventory/search-filter';
import { Checkbox } from './checkbox';

import './facet-checkbox.scss';

export const DEFAULT_VISIBLE_VALUES_NUMBER = 4;
const DEFAULT_EMPTY_ARRAY = [];

/**
 * Renders visible number of checkboxes and if there are more
 * values then hide them into collapse section.
 */
export class FacetCheckbox extends Component {
  static propTypes = {
    values: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
        id: PropTypes.string,
        count: PropTypes.number,
        selected: PropTypes.bool,
        price: PropTypes.shape({}),
      })
    ),
    collapseText: PropTypes.shape({}),
    visibleValues: PropTypes.number,
    onUpdate: PropTypes.func.isRequired,
    hideCount: PropTypes.bool,
    disableTracking: PropTypes.bool,
    normalSize: PropTypes.bool,
    showCollapseIcon: PropTypes.bool,
    showPrice: PropTypes.bool,
    combineValues: PropTypes.bool,
    listClasses: PropTypes.string,
    checkboxClasses: PropTypes.string,
    labelClasses: PropTypes.string,
    collapseClasses: PropTypes.string,
    description: PropTypes.string,
    facetName: PropTypes.string.isRequired,
    additionalContent: PropTypes.element,
    isContrastUpdate: PropTypes.bool,
  };

  static defaultProps = {
    values: [],
    visibleValues: DEFAULT_VISIBLE_VALUES_NUMBER,
    hideCount: false,
    disableTracking: false,
    normalSize: false,
    showCollapseIcon: false,
    showPrice: false,
    combineValues: false,
    listClasses: 'px-0_5 px-md-1',
    checkboxClasses: '',
    labelClasses: '',
    collapseClasses: 'text-gray-dark',
    description: '',
    collapseText: {
      less: 'show less',
      more: 'show more',
    },
    additionalContent: null,
    isContrastUpdate: false,
  };

  state = {
    collapse: false,
  };

  /**
   * Toggles more/less items visibility.
   */
  toggleCollapse = () => {
    this.setState(prevState => ({
      collapse: !prevState.collapse,
    }));
  };

  /**
   * Renders checkbox.
   * @param {object} facet
   * @returns {ReactElement}
   */
  renderCheckbox = facet => {
    const { value, id, name } = facet;
    const { onUpdate, hideCount, facetName, disableTracking, normalSize, checkboxClasses, labelClasses, showPrice } =
      this.props;
    const key = value || id || name;
    return (
      <Checkbox
        onUpdate={onUpdate}
        hideCount={hideCount}
        key={key}
        facet={facet}
        facetName={facetName}
        disableTracking={disableTracking}
        normalSize={normalSize}
        checkboxClasses={checkboxClasses}
        labelClasses={labelClasses}
        showPrice={showPrice}
        isContrastUpdate={this.props.isContrastUpdate}
      />
    );
  };

  render() {
    const {
      values,
      visibleValues,
      listClasses,
      collapseClasses,
      additionalContent,
      description,
      normalSize,
      collapseText,
      showCollapseIcon,
      combineValues,
    } = this.props;
    const { collapse } = this.state;
    const { renderCheckbox } = this;

    let firstPart;
    let secondPart;

    if (combineValues) {
      firstPart = combineFacetValues(values);
      secondPart = DEFAULT_EMPTY_ARRAY;
    } else {
      firstPart = values.slice(0, visibleValues);
      secondPart = values.slice(firstPart.length);
    }

    const listClassName = classNames('m-0', listClasses, { small: !normalSize });
    const showHideText = collapse ? collapseText.less : collapseText.more;
    return (
      <Fragment>
        <div className="facet-checkbox">
          {Boolean(firstPart.length) && <ul className={listClassName}>{firstPart.map(renderCheckbox)}</ul>}
          {Boolean(secondPart.length) && (
            <AnimatedCollapse isOpen={collapse}>
              <ul className={listClassName}>{secondPart.map(renderCheckbox)}</ul>
            </AnimatedCollapse>
          )}
          {(Boolean(secondPart.length) || additionalContent) && (
            <div className="d-flex px-0_5 px-md-1 mb-0_5 justify-content-between">
              {Boolean(secondPart.length) && (
                <button
                  onClick={this.toggleCollapse}
                  className={classNames('show-more border-0 px-0', collapseClasses, { small: !normalSize })}
                >
                  {`${showHideText}`}
                  {showCollapseIcon && (
                    <span
                      className={classNames('ms-0_25', {
                        'icon-arrow-up3': collapse,
                        'icon-arrow-down3': !collapse,
                      })}
                      aria-hidden
                    />
                  )}
                </button>
              )}
              {additionalContent}
            </div>
          )}
        </div>

        {description && <div className="small px-0_5 px-2_5 px-lg-1 pb-0_5">{description}</div>}
      </Fragment>
    );
  }
}
